<div class="form-group required-field-item" *ngFor="let field of fieldStates">
  <label [for]="'policy-field-' + field.id" class="required-field-label">
    {{ field.fieldLabel }}
    <span *ngIf="field.isRequired" class="required-asterisk">*</span>
  </label>
  <div class="required-field-helper" *ngIf="field.helperText">{{ field.helperText }}</div>
  <input
    *ngIf="field.fieldType !== fieldTypes.None"
    type="text"
    class="form-control"
    [id]="'policy-field-' + field.id"
    [placeholder]="field.placeholder"
    [(ngModel)]="field.value"
    (ngModelChange)="onFieldInput(field)"
  />
  <textarea
    *ngIf="field.fieldType === fieldTypes.None"
    class="form-control"
    rows="3"
    [id]="'policy-field-' + field.id"
    [placeholder]="field.placeholder"
    [(ngModel)]="field.value"
    (ngModelChange)="onFieldInput(field)"
  ></textarea>
  <div class="field-error" *ngIf="fieldErrors[field.id]">
    {{ fieldErrors[field.id] }}
  </div>
</div>
